import { adminAxios } from '../helpers/api';

export const getOrderDetail = (orderId) =>
  adminAxios.get(`invoices/${orderId}`, {
    params: {
      include: 'invoicePriceDetails,orders.product,paymentMethod,orderType',
    },
  });
